export const PERCENTAGE = {
  MULTIPLIER: 100,
} as const;
